import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
// import createPersistedState from 'vuex-persistedstate';
// import * as Cookies from 'js-cookie';

import getters from './getters';

import natural from './modules/natural';
import corporate from './modules/corporate';
import product from './modules/product';
import user from './modules/user';
import risk from './modules/risk';
import tax from './modules/tax';

Vue.use(Vuex);

const debug = process.env.NODE_ENV === 'development';

export default new Vuex.Store({
  modules: {
    user,
    natural,
    corporate,
    product,
    risk,
    tax,
  },
  getters,
  strict: debug,
  plugins: debug ? [createLogger()] : [],
  // plugins: debug ? [createPersistedState(), createLogger()] : [createPersistedState()],
});
